


import * as basicData from './basicData/index'
import * as searchData from './searchData/index'
export default {
    basicData,
    searchData
}